import { Component, OnDestroy, OnInit, ViewChild, TemplateRef, ChangeDetectorRef, ViewEncapsulation, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, AfterViewInit, OnChanges } from '@angular/core';
import { UntypedFormGroup, FormControl, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms'
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { CustomerService } from '../../services/customer.service'
import { MessageService } from 'primeng/api';
import { debounceTime, map, distinctUntilChanged, filter } from 'rxjs/operators';


@Component({
  selector: 'app-ar-interest-invoices',
  templateUrl: './ar-interest-invoices.component.html',
  styleUrls: ['./ar-interest-invoices.component.scss']
})
export class ArInterestInvoicesComponent implements OnInit {

	color: any = '';
	ardata: any = [];
	filteredardata: any = [];
	config: any = false;
	searchForm: UntypedFormGroup;
	searchText: any = new UntypedFormControl('');
	openAccordion = -1;
	loading: any = false;
	
	constructor(
		private formBuilder: UntypedFormBuilder,
		private globalSearchService: GlobalSearchService,
		private customerService: CustomerService,
		private messageService: MessageService,
	) {
		this.color = this.globalSearchService.color;
		this.searchForm = this.formBuilder.group({
			cutoffvalue: [0],
			cutoffdate: [new Date()],
		});
		
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		})
	}
		
	
	ngOnInit(): void {
	
		
		this.refreshData();
		this.searchText.valueChanges.pipe(
			debounceTime(300) // Add a small delay to avoid filtering on every keystroke
		).subscribe((filterValue) => {
			this.filterData();
		});

	}
	
	refreshData() {
	    this.loading = true;
		this.customerService.getARInvoices(this.searchForm.value).subscribe((results: any) => {
			this.ardata = results;
			this.filterData();
			this.loading = false;
		});
	}
	
	filterData(){
		if (!this.searchText.value) {
			this.filteredardata = [...this.ardata.totaldebtors];
		} else {
			const lowerCaseFilter = this.searchText.value.toLowerCase();
			this.filteredardata = this.ardata.totaldebtors.filter(tran =>
				tran.debtorname?.toLowerCase().includes(lowerCaseFilter) ||
				tran.debtorno?.toString().includes(lowerCaseFilter) ||
				tran.termscode?.toLowerCase().includes(lowerCaseFilter)
			);
		}
	}
	
	flipSelection(){
		this.filteredardata.forEach((ardata) => {
			let currindex = this.ardata.totaldebtors.indexOf(ardata);
			if(currindex != -1){
			this.ardata.totaldebtors[currindex].selected = this.ardata.totaldebtors[currindex].selected ? false : true;
			}
		});
		this.filterData();
	}
	
	getCount(){
		let count = 0;
		this.ardata.totaldebtors.forEach((record) => {
			if(record.selected){
			count = count + 1;
			}
		});
		
		return count;
	}
	
	processInvoices(){
	
		if(confirm('Process Invoices for selected customers?')){
		
		const data = {process: this.getSelectedRecords() }
		this.customerService.processARInterest(data).subscribe((results) => {
		console.log(results);
		if(results.errors == 0){
		   this.globalSearchService.showNotification('All Invoices Processed', 'success', 'bottom', 'right');
		   this.ardata = [];
		   this.filteredardata = [];
		} else {
		 this.globalSearchService.showNotification(results.proceseed+' Invoices Processed, '+results.errors+' Errors', 'warning', 'bottom', 'right');
		 this.ardata = [];
		 this.filteredardata = [];
		}
		});
		
		
		}
	}
	
	getTotal(){
		let total = 0;
		this.ardata.totaldebtors.forEach((record) => {
			if(record.selected){
			total = total + record.totalcharge;
			}
		});
		return total;
	}
	
	getSelectedRecords(){
	let newlist = new Array();
	this.ardata.totaldebtors.forEach((record) => {
			if(record.selected){
			newlist.push(record); 
			}
		});
	return newlist;
	}
	back(){
	
	}
}
